// React Imports
import type { SVGAttributes } from 'react';

export const MyHub = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M18.2946 19.5189H7.46603C6.9832 19.5189 6.59135 19.1271 6.59135 18.6443V13.788C6.59135 11.8637 8.15528 10.2998 10.0796 10.2998C12.0039 10.2998 13.5678 11.8637 13.5678 13.788V14.9321H17.3324V7.58828L9.96062 2.75304L2.5853 7.58828V18.6443C2.5853 19.1271 2.19344 19.5189 1.71062 19.5189C1.2278 19.5189 0.835938 19.1271 0.835938 18.6443V7.11595C0.835938 6.82206 0.982886 6.54566 1.2313 6.38472L9.4813 0.975683C9.77169 0.786752 10.1496 0.786752 10.4399 0.975683L18.6864 6.38472C18.9314 6.54566 19.0818 6.82206 19.0818 7.11595V15.8068C19.0818 16.2896 18.6899 16.6815 18.2071 16.6815H12.6931C12.2103 16.6815 11.8184 16.2896 11.8184 15.8068V13.788C11.8184 12.8294 11.0382 12.0492 10.0796 12.0492C9.12093 12.0492 8.34071 12.8294 8.34071 13.788V17.7696H18.2946C18.7774 17.7696 19.1693 18.1614 19.1693 18.6443C19.1693 19.1271 18.7774 19.5189 18.2946 19.5189Z"
        fill="#424242"
      />
      <path
        d="M10.1812 9.55763C9.19102 9.55763 8.38281 8.74942 8.38281 7.75928C8.38281 6.76914 9.19102 5.96094 10.1812 5.96094C11.1713 5.96094 11.9795 6.76564 11.9795 7.75928C11.9795 8.74942 11.1713 9.55763 10.1812 9.55763Z"
        fill="#424242"
      />
    </svg>
  );
};

export const MyHubGold = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M18.2946 19.5189H7.46603C6.9832 19.5189 6.59135 19.1271 6.59135 18.6443V13.788C6.59135 11.8637 8.15528 10.2998 10.0796 10.2998C12.0039 10.2998 13.5678 11.8637 13.5678 13.788V14.9321H17.3324V7.58828L9.96062 2.75304L2.5853 7.58828V18.6443C2.5853 19.1271 2.19344 19.5189 1.71062 19.5189C1.2278 19.5189 0.835938 19.1271 0.835938 18.6443V7.11595C0.835938 6.82206 0.982886 6.54566 1.2313 6.38472L9.4813 0.975683C9.77169 0.786752 10.1496 0.786752 10.4399 0.975683L18.6864 6.38472C18.9314 6.54566 19.0818 6.82206 19.0818 7.11595V15.8068C19.0818 16.2896 18.6899 16.6815 18.2071 16.6815H12.6931C12.2103 16.6815 11.8184 16.2896 11.8184 15.8068V13.788C11.8184 12.8294 11.0382 12.0492 10.0796 12.0492C9.12093 12.0492 8.34071 12.8294 8.34071 13.788V17.7696H18.2946C18.7774 17.7696 19.1693 18.1614 19.1693 18.6443C19.1693 19.1271 18.7774 19.5189 18.2946 19.5189Z"
        fill="url(#paint0_linear_8363_208202)"
      />
      <path
        d="M10.1812 9.55763C9.19102 9.55763 8.38281 8.74942 8.38281 7.75928C8.38281 6.76914 9.19102 5.96094 10.1812 5.96094C11.1713 5.96094 11.9795 6.76564 11.9795 7.75928C11.9795 8.74942 11.1713 9.55763 10.1812 9.55763Z"
        fill="url(#paint1_linear_8363_208202)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8363_208202"
          x1="10.0026"
          y1="0.833984"
          x2="10.0026"
          y2="19.5189"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8363_208202"
          x1="10.1812"
          y1="5.96094"
          x2="10.1812"
          y2="9.55763"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
